var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var $ = require("./lib/qsa");
var dot = require("./lib/dot");
var templateSource = require("./_content.html");
var template = dot.compile(templateSource);

async function init(pymChild) {
  if (window.location.hostname == "apps.npr.org") {
    var request = await fetch("https://apps.npr.org/dailygraphics/data/sheets/music-end-of-year-agg-2022-20221121.json");
    var copy = await request.json();
    var data = copy;
    var content = template(data);
    var graphicEl = $.one("#graphic");

    graphicEl.innerHTML = content;
  }
  pymChild.sendHeight();
}

var onWindowLoaded = function() {

  pym.then(child => {

      init(child);
      child.sendHeight();

      child.onMessage("on-screen", function(bucket) {
          ANALYTICS.trackEvent("on-screen", bucket);
      });
      child.onMessage("scroll-depth", function(data) {
          data = JSON.parse(data);
          ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      });

      window.addEventListener("resize", () => child.sendHeight());
  });
}

// wait for images to load
window.onload = onWindowLoaded;
